import React from 'react';
import Link from 'gatsby-link';
// import FCCSearch from 'react-freecodecamp-search';

import NavLogo from './components/NavLogo';
import UserState from './components/UserState';

import './header.css';

function Header() {
  return (
    <header>
      <nav id='top-nav'>
        <a className='home-link' href='https://school.quest.ac'>
          <NavLogo />
        </a>
        <ul id='top-right-nav'>
          <li>
            <Link to='/'>Home</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js